import { EditorState } from 'prosemirror-state';
import { useCallback, useState } from 'react';
import { getEditorState } from 'conversations-thread-data/common-reply/public/operators/commonReplyGetters';
import { schema } from 'hubspot-prosemirror/prosemirror/ProsemirrorSchema';
import { editorStateHasContent } from '../operators/editorStateHasContent';
export function useBaseEditorState(reply, draft) {
  const [state, setState] = useState(() => {
    const editorStateFromReply = getEditorState(reply);
    if (editorStateFromReply && editorStateHasContent(editorStateFromReply)) {
      return editorStateFromReply;
    } else if (draft && draft.data) {
      return draft.data;
    }
    return EditorState.create({
      schema
    });
  });
  const resetState = useCallback(() => {
    setState(EditorState.create({
      schema
    }));
  }, []);
  return [state, setState, resetState];
}